import i18n from '@/lang/i18n'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-enterprise/all-modules'

export const sectionSampleGridColumnDefs: (ColDef | ExportedColDef | ExportedColGroupDef)[] = [
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('globalLocator.labels.sampleTag'),
        colId: 'samLabel',
        field: 'sampleLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.sampleId'),
        colId: 'samSampleNumber',
        field: 'sampleNumber',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        hide: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.sampleType'),
        field: 'sampleType.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.status'),
        field: 'status',
        colId: 'status.code',
        type: AgGridColumnType.COMMON_SAMPLE_STATUS,
        exportField: 'status.name',
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.location'),
        field: 'topographicCode.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.procedure'),
        field: 'procedure.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.probableDiagnosis'),
        field: 'mostLikelyMorphologicCode.description',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.conservationMedium'),
        colId: 'samConservation',
        field: 'conservation',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.productionDate'),
        field: 'samSamplingDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.responsibleGrossing'),
        colId: 'grossingResponsible.normalizedFullName',
        field: 'responsibleForGrossing.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.controllerGrossing'),
        colId: 'grossingTech.normalizedFullName',
        field: 'grossingControllerTechnician.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.nonPathologistSpecialist'),
        colId: 'specialist.normalizedFullName',
        field: 'specialist.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.grossingTutor'),
        colId: 'grossingTutor.normalizedFullName',
        field: 'grossingTutor.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.grossingDate'),
        field: 'lastGrossingDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.observations'),
        field: 'observations',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true,
        sortable: false
    },
    {
        headerName: i18n.tc('globalLocator.labels.incidents'),
        field: 'incidentsCount',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        minWidth: 200,
        flex: 1
    },
    {
        headerName: i18n.tc('globalLocator.labels.attachments'),
        field: 'attachmentsCount',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        minWidth: 200,
        flex: 1
    },
    {
        headerName: i18n.tc('globalLocator.labels.wasteDate'),
        colId: 'samDisposalDate',
        field: 'disposalDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.wasteTechnician'),
        colId: 'wasteTechnician.normalizedFullName',
        field: 'wasteTechnician.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('global.laboratory'),
        field: 'currentLaboratory.labName',
        type: AgGridColumnType.LABORATORIES,
        exportType: AgGridExportType.TEXT
    }
]
